export default __webpack_public_path__ + "d285a5e56842dad0a13cd3e8f847f202.png";